import * as React from 'react'
import * as Walkers from '@avcan/schema/walkers'
import * as UI from '@avcan/schema/ui'
import * as Root from '../contexts/root'
import * as Form from '../contexts/form'

export function useUISchema(name) {
    const ui = Root.useFormSchema()

    return React.useMemo(() => {
        return name ? UI.get(ui, name) : ui
    }, [ui, name])
}
export function useSubSchema(name) {
    const schema = Root.useDataSchema()

    return React.useMemo(() => {
        try {
            Walkers.get(schema, name)
        } catch (subschema) {
            // Throws when subschema has been found
            return subschema
        }
    }, [schema, name])
}
export function useWidget(name) {
    const widgets = Form.useWidgets()

    return widgets.get(name)
}
